import React, { useState, createContext, useContext } from 'react';
import { BrowserRouter as Router, Route, Navigate, Routes } from 'react-router-dom';
import PrivateRoute from "./utils/privateRoute";
import Login from './components/auth/login';
import Code from './components/auth/code';
import { useSelector } from 'react-redux';
import Dashboard from './components/dashboard/dashboard';
import AddAPlace from './components/addaplace/addaplace';
import EditPlace from './components/addaplace/editplace';
import LoggedInLayout from './components/header/loggedInLayout';
function AppRouter() {
    const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
    return (
      <Router>
        <Routes>
            {isAuthenticated ? (
              <>
                <Route element={<LoggedInLayout />}>
          <Route path="/" element={<Dashboard />} />
          <Route path="/addplace" element={<AddAPlace/>}/>
          <Route path="/editplace/:id" element={<EditPlace/>}/>
          </Route>

          </>
            ) : (
                <>
                  <Route path="/" element={<Login/>} />
                  <Route path="/code" element={<Code/>}/>
                </>
            )}
        </Routes>
      </Router>
    );
  }
  
  

  export default AppRouter;
